<header role="banner" id="global-header" class="with-proposition aa-contrast-header" aria-hidden="true">
  <div class="header-wrapper aa-contrast-header">
    <div class="header-global">
      <div class="header-logo">
        <span class="content aa-contrast-header"><app-svg-crown aria-hidden="true"></app-svg-crown> {{globalHeaderText}}</span>
      </div>
    </div>
    <div class="header-proposition">
      <div class="content">
        <span id="proposition-name" class="aa-contrast-header">{{appTitle}}</span>
      </div>
    </div>
  </div>
</header>
<div *ngIf="!shouldShowFamiliarisationBar" id="global-header-bar"></div>
<div *ngIf="shouldShowFamiliarisationBar" id="familiarisation-header-bar" class="aa-copy-size aa-contrast-block">Try it out</div>
